import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { UserStore } from '@core/stores';

export const clearSessionIdResolver: ResolveFn<boolean> = () => {
  const store = inject(UserStore);
  store.onClearSessionId();

  return true;
};
